export default ({ emailDisplayName, ...rest }) => ({
  ...rest,
  leadsFormEmailDisplayName: emailDisplayName,
});
